import axios from '../_helpers/axios';

export const maintenance_reminderService = {
    get_maintenance_reminder_by_account,
};

async function get_maintenance_reminder_by_account(data) {
  return new Promise((resolve, reject) => {
    axios.post('maintenance_reminder_by_account', data)
    .then(resp => {
        if(resp.data && resp.data.data){
          resolve(resp.data.data)
        }
    }).catch(function(error){
      if (error.response && error.response.data && error.response.data.error) {
        reject(error.response.data.error.error_message)
        return
      }
      reject(error)
    })
  })
}
